import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CdkDragDrop,
  CdkDrag,
  CdkDropList,
  moveItemInArray,
  DragDropModule,
} from '@angular/cdk/drag-drop';
import { CardWidgetComponent } from '../../components/card-widget/card-widget.component';
import { AddWidgetsComponent } from '../../components/add-widgets/add-widgets.component';
import { WIDGET } from '../../../../shared/interfaces/widget';
import { DataService } from '../../../../services/dashboard/data.service';
import { ActivatedRoute } from '@angular/router';
import { ModalActivitiesSelectionComponent } from './components/modal-activities-selection/modal-activities-selection.component';
import { RecentViewedList } from '../../../../shared/interfaces/home-recent-viewed';
import { RecentlyViewedComponent } from '../../home/components/recently-viewed/recently-viewed.component';
import { GenerateNationalReportComponent } from './components/generate-national-report/generate-national-report.component';
import { Router } from '@angular/router';
import { DmtUtilityService } from '../../../../services/dashboard/dmt-utility.service';
import { WIDGET_LAYOUT } from '../../../../shared/interfaces/widgetLayout';
import { WidgetScope } from '../../../../shared/enums/widgetScope.enum';
import { WIDGET_LAYOUT_MAP } from '../../../../shared/data/widgetLayoutMap.data';
import { UserService } from '../../../../services/users/user.service';
import { TooltipsInterface } from '../../../../shared/interfaces/nt-tooltips';
import { TOOLTIPS_NT } from '../../../../shared/data/tooltipsNT.data';
import { UserPreference } from '../../../../shared/interfaces/userPreference.interface';
import { catchError, forkJoin, of } from 'rxjs';
import { LaunchConfirmationBannerComponent } from './components/launch-confirmation-banner/launch-confirmation-banner.component';

@Component({
  selector: 'app-national',
  imports: [
    CdkDropList,
    CdkDrag,
    CommonModule,
    CardWidgetComponent,
    AddWidgetsComponent,
    DragDropModule,
    ModalActivitiesSelectionComponent,
    GenerateNationalReportComponent,
    LaunchConfirmationBannerComponent,
  ],
  templateUrl: './national.component.html',
  styleUrl: './national.component.css',
})
export class NationalComponent implements OnInit {
  isAddWidgetsOpen: boolean = false;
  //allWidgets: WIDGET[] = [];
  allWidgets: WIDGET_LAYOUT[] = [];
  //selectedWidgets: WIDGET[] = [];
  selectedWidgets: WIDGET_LAYOUT[] = [];
  isEditMode: boolean = false;
  isDragging: boolean = false;

  companyId: number | null = null;
  isModalActivitiesOpen: boolean = false;
  isAccessCurveOpen: boolean = false;
  isMarketCurveOpen: boolean = false;
  toRecentlyViewed: RecentViewedList = {} as RecentViewedList;
  medicineId?: number;
  medicineInfo: any;
  medicineName: string | null = '';
  countryId: number | null = null;
  isMedicineLaunched: boolean = false;

  isGenerateNationalPPTModuleOpen: boolean = false;

  isLoading: boolean = false;
  // true only when GET /user-preferences/me succeeded: selectedWidgets (with the title
  // choices) is saved only then, so a failed load can't overwrite them with defaults
  userPreferencesLoaded: boolean = false;
  tooltipsNationalDashboard: TooltipsInterface[] = TOOLTIPS_NT;

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private us: DmtUtilityService,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    // send event to open platform to the user in the sidebar
    window.dispatchEvent(new CustomEvent('isDashboardOpen', { detail: true }));
    window.dispatchEvent(
      new CustomEvent('inWhichPage', { detail: 'NATIONAL' }),
    );

    sessionStorage.setItem('solution', 'Territorial');

    const id = Number(this.route.snapshot.paramMap.get('id'));

    //this.allWidgets = this.dataService.defaultWidgetsInDashboard;
    //console.log("ALLWIDGETS:",this.allWidgets)
    //this.selectedWidgets = this.allWidgets.filter(widget => widget.onDashboard);
    this.loadDashboardWidgets();
    this.checkWidgetsLayout();

    const companyIdString = sessionStorage.getItem('companyId');
    this.companyId = companyIdString ? parseInt(companyIdString, 10) : null;
    this.dataService.actualCompanyId = this.companyId;
    this.dataService.actualMedicineId = id;

    this.medicineId = this.dataService.actualMedicineId;
    this.medicineName = sessionStorage.getItem('businessName');
    this.countryId = this.us.getSessionVariableNumber('countryId', 1);

    if (this.companyId !== null) {
      this.dataService.getMedicinesByCompanyId(this.companyId).subscribe({
        next: (medicines) => {
          const medicine = medicines.find((m) => m.id === id);
          if (medicine && this.medicineId === id) {
            this.isMedicineLaunched = this.isMedicineLaunched || medicine.launched;
          }
        },
        error: (err) => {
          console.error('Errore nel caricamento:', err);
        },
      });
    }
    this.buildRecentViewed();
  }

  loadDashboardWidgets() {
    this.isLoading = true;
    // /widgets/NATIONAL stays the source of truth (availability, visibility, order, names);
    // the user preferences only add the title choice (isDefaultName) of each widget.
    // Both are awaited before the widgets are shown, so nothing can be saved without the titles.
    // If the preferences fail, the widgets still load with the default titles,
    // but selectedWidgets is not saved (see savePreferences) to avoid overwriting the saved titles.
    this.userPreferencesLoaded = false;
    let preferencesFailed = false;
    forkJoin({
      response: this.dataService.getDashboardWidgetsLayout(WidgetScope.NATIONAL),
      preferences: this.userService.getUserPreferences().pipe(
        catchError((err) => {
          console.error('Error loading user preferences', err);
          preferencesFailed = true;
          return of(null);
        }),
      ),
    }).subscribe({
      next: ({ response, preferences }) => {
        this.userPreferencesLoaded = !preferencesFailed;
        const titlePreferences = this.getTitlePreferences(preferences);

        this.allWidgets = response
          .map((w: any) => {
            const layout = WIDGET_LAYOUT_MAP[w.widgetId];

            return {
              ...layout,
              id: w.widgetId,
              name: w.widgetName,
              visible: w.visible,
              order: w.order,
              isDefaultName: titlePreferences.get(w.widgetId) ?? true,
            };
          })
          .sort((a: any, b: any) => a.order - b.order);
        //console.log("ALLWIDGETS:",this.allWidgets)
        this.selectedWidgets = this.allWidgets
          .filter((w) => w.visible)
          .sort((a: any, b: any) => a.order - b.order);
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error loading dashboard widgets', err);
      },
    });
  }

  // widgetId -> saved title choice; missing/null entries are left out (default title)
  private getTitlePreferences(preferences: UserPreference | null): Map<number, boolean> {
    const titlePreferences = new Map<number, boolean>();
    (preferences?.selectedWidgets ?? []).forEach((saved) => {
      if (saved.isDefaultName !== null && saved.isDefaultName !== undefined) {
        titlePreferences.set(saved.widgetId, saved.isDefaultName);
      }
    });
    return titlePreferences;
  }

  // Copies the current dashboard position of the visible widgets into their `order`,
  // in both lists, so a later add/remove (which sorts by `order`) keeps the user's layout.
  private syncWidgetsOrder(): void {
    const positions = new Map<number, number>();
    this.selectedWidgets.forEach((w, index) => positions.set(w.id, index));

    this.selectedWidgets = this.selectedWidgets.map((w, index) => ({ ...w, order: index }));
    this.allWidgets = this.allWidgets.map((w) =>
      positions.has(w.id) ? { ...w, order: positions.get(w.id) } : w,
    );
  }

  /*
  // to show before database ready for id 16
loadDashboardWidgets() {
  this.isLoading = true;
  this.dataService.getDashboardWidgetsLayout(WidgetScope.NATIONAL).subscribe({
    next: (response) => {
      // TODO: rimuovere quando il backend supporta il widget 15
      const HARDCODED_WIDGETS = [
        {
          id: 16,
          name: 'Curva di Apertura in Economia',
          visible: true,
          className: 'widget-curva-economia',
          fixedWidth: true,
          goLarge: false,
          order: 0, // mettilo in fondo, o aggiusta l'ordine a piacere
        },
      ];

      const backendIds = new Set(response.map((w: any) => w.widgetId));

      this.allWidgets = [
        ...response.map((w: any) => {
          const layout = WIDGET_LAYOUT_MAP[w.widgetId];
          return {
            ...layout,
            id: w.widgetId,
            name: w.widgetName,
            visible: w.visible,
            order: w.order,
          };
        }),
        // aggiunge solo i widget hardcoded non già presenti nel backend
        ...HARDCODED_WIDGETS.filter((hw) => !backendIds.has(hw.id)),
      ].sort((a: any, b: any) => a.order - b.order);

      this.selectedWidgets = this.allWidgets
        .filter((w) => w.visible)
        .sort((a: any, b: any) => a.order - b.order);

      this.isLoading = false;
    },
    error: (err) => {
      this.isLoading = false;
      console.error('Error loading dashboard widgets', err);
    },
  });
}
*/

  /** To build the recent viewed to send to the data service  */
  buildRecentViewed() {
    if (this.toRecentlyViewed.url?.solution === 'national') return;

    this.toRecentlyViewed.title = 'Nazione';
    this.toRecentlyViewed.medicineName =
      sessionStorage.getItem('businessName') || '';
    this.toRecentlyViewed.date = new Date().toLocaleString('sv-SE', {
      timeZone: 'Europe/Rome',
    });
    this.toRecentlyViewed.type = 'nation';

    if (this.medicineId != null) {
      this.toRecentlyViewed.url = {
        solution: 'territorial',
        medicineId: this.medicineId,
      };
    }

    const username = sessionStorage.getItem('username') || '';
    const companyId = this.us.getSessionVariableNumber('companyId', 0);

    this.dataService.addToRecentViewed(
      this.toRecentlyViewed,
      username,
      companyId,
    );
  }

  private checkWidgetsLayout(): void {
    setTimeout(() => {
      const container = document.querySelector('[cdkDropList]');
      if (!container) return;

      const children = Array.from(container.children) as HTMLElement[];
      // Resetta goLarge a false per tutti i widget
      this.selectedWidgets = this.selectedWidgets.map((w) => ({
        ...w,
        goLarge: false,
      }));

      // Funzione per trovare una chiave top “vicina” già presente in rows, con tolleranza
      function findCloseTopKey(
        rows: Record<number, any>,
        top: number,
        tolerance = 50,
      ): number | null {
        for (const keyStr of Object.keys(rows)) {
          const key = Number(keyStr);
          if (Math.abs(key - top) <= tolerance) {
            return key;
          }
        }
        return null;
      }

      const rows: Record<number, { fixed: number[]; notFixed: number[] }> = {};

      children.forEach((child, idx) => {
        const widget = this.selectedWidgets[idx];
        if (!widget) return;

        const top = child.offsetTop;
        const topKey = findCloseTopKey(rows, top, 500) ?? top;

        if (!rows[topKey]) {
          rows[topKey] = { fixed: [], notFixed: [] };
        }

        if (widget.fixedWidth) {
          rows[topKey].fixed.push(widget.id);
        } else {
          rows[topKey].notFixed.push(widget.id);
        }
      });

      Object.keys(rows).forEach((top) => {
        const row = rows[+top];

        // Se ci sono sia fixed che notFixed in riga, i notFixed diventano goLarge true
        if (row.fixed.length > 0 && row.notFixed.length > 0) {
          this.selectedWidgets = this.selectedWidgets.map((w) => {
            if (row.notFixed.includes(w.id)) {
              return { ...w, goLarge: true };
            }
            return w;
          });
        }

        // Se ci sono più di un notFixed sulla stessa riga, tutti loro vanno a goLarge false (override)
        if (row.notFixed.length > 1) {
          this.selectedWidgets = this.selectedWidgets.map((w) => {
            if (row.notFixed.includes(w.id)) {
              return { ...w, goLarge: false };
            }
            return w;
          });
        }

        // Se ce' un solo notfixed si allarga
        if (row.notFixed.length == 1) {
          this.selectedWidgets = this.selectedWidgets.map((w) => {
            if (row.notFixed.includes(w.id)) {
              return { ...w, goLarge: true };
            }
            return w;
          });
        }
      });

      this.selectedWidgets = [...this.selectedWidgets];
    }, 0);
  }

  /*drop(event: CdkDragDrop<any[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(
        this.selectedWidgets,
        event.previousIndex,
        event.currentIndex,
      );

      this.dataService.defaultWidgetsInDashboard =
        this.dataService.defaultWidgetsInDashboard.map((widget) => {
          const isOnDashboard = this.selectedWidgets.some(
            (sw) => sw.id === widget.id,
          );
          return { ...widget, onDashboard: isOnDashboard };
        });

      this.selectedWidgets = [...this.selectedWidgets];
      this.checkWidgetsLayout();
    }
  }*/

  drop(event: CdkDragDrop<WIDGET_LAYOUT[]>) {
    if (event.previousIndex === event.currentIndex) {
      return;
    }

    moveItemInArray(
      this.selectedWidgets,
      event.previousIndex,
      event.currentIndex,
    );

    // Force change detection + keep `order` in allWidgets aligned with the new layout
    this.syncWidgetsOrder();

    this.savePreferences();
    this.checkWidgetsLayout();
  }

  //onWidgetsUpdated (updated: WIDGET[]) {
  onWidgetsUpdated(updated: WIDGET_LAYOUT[]) {
    // Widgets already on the dashboard keep their current position (and title choice);
    // the newly added ones go after them, sorted by their `order`.
    // A new widget keeps a title choice it already had in this session, otherwise default title.
    const updatedById = new Map(updated.map((w) => [w.id, w]));
    const currentIds = new Set(this.selectedWidgets.map((w) => w.id));

    this.allWidgets = updated.map((w) => ({ ...w, isDefaultName: w.isDefaultName ?? true }));

    const keptWidgets = this.selectedWidgets
      .filter((w) => updatedById.get(w.id)?.visible)
      .map((w) => ({ ...w, ...updatedById.get(w.id)!, isDefaultName: w.isDefaultName ?? true }));
    const addedWidgets = this.allWidgets
      .filter((w) => w.visible && !currentIds.has(w.id))
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    this.selectedWidgets = [...keptWidgets, ...addedWidgets];
    this.syncWidgetsOrder();
    //this.selectedWidgets = this.allWidgets.filter(w => w.onDashboard);
    //this.dataService.defaultWidgetsInDashboard = this.allWidgets;
    this.savePreferences();
    this.checkWidgetsLayout();
  }

  onDeleteWidget(widgetId: number) {
    this.allWidgets = this.allWidgets.map((w) =>
      w.id === widgetId ? { ...w, visible: false } : w,
    );

    // Remove it without re-sorting, so the remaining widgets keep the user's layout
    this.selectedWidgets = this.selectedWidgets.filter((w) => w.id !== widgetId);
    this.syncWidgetsOrder();
    //this.selectedWidgets = this.allWidgets.filter(w => w.onDashboard);
    //this.dataService.defaultWidgetsInDashboard = this.allWidgets;
    this.savePreferences();
    this.checkWidgetsLayout();
  }

  // Title chosen in the card dropdown: true = default name, false = alternative name
  onWidgetTitleSelected(widgetId: number, isDefaultName: boolean) {
    this.selectedWidgets = this.selectedWidgets.map((w) =>
      w.id === widgetId ? { ...w, isDefaultName } : w,
    );
    this.allWidgets = this.allWidgets.map((w) =>
      w.id === widgetId ? { ...w, isDefaultName } : w,
    );
    this.savePreferences();
  }

  savePreferences() {
    if (!this.userPreferencesLoaded) {
      console.warn('User preferences not loaded: dashboard widgets changes are not saved');
      return;
    }
    //const selected = this.allWidgets.filter((w) => w.visible);
    const username = sessionStorage.getItem('username') || '';
    const payload = {
      username: username,
      companyId: this.companyId,
      selectedWidgets: this.selectedWidgets.map((w, index) => ({
        widgetId: w.id,
        order: index,
        isDefaultName: w.isDefaultName ?? true,
      })),
    };

    this.userService.updateUserPreferences(payload).subscribe({
      next: () => {
        //  console.log('Preferences saved');
      },
      error: (err) => console.error('Save failed', err),
    });
  }

  trackById(index: number, item: any): number {
    return item.id;
  }

  openAddWidgets() {
    this.isAddWidgetsOpen = true;
    // this.isEditMode = false;
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
  }

  openModalAddWidgetsFromChild(event: boolean): void {
    this.isAddWidgetsOpen = event;
    document.body.style.overflow = '';
    document.body.style.width = '';
  }

  toggleEditMode(status: boolean) {
    this.isEditMode = status;
  }

  handleModalActivitiesToggle(value: boolean) {
    this.isModalActivitiesOpen = value;

    if (this.isModalActivitiesOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

  onOpenAccessCurveFromWidget(value: boolean) {
    this.isAccessCurveOpen = value;

    if (this.isAccessCurveOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

  onOpenMarketCurveFromWidget(value: boolean) {
    this.isMarketCurveOpen = value;
    if (this.isMarketCurveOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

  onShowGenNationalPPTModal(): void {
    this.dataService.getMedicineInfoById(this.medicineId || 0).subscribe({
      next: (medicineInfo) => {
        this.medicineInfo = medicineInfo;
      },
      error: (error) => {
        console.error('Error fetching medicine info:', error);
      },
    });
  }

  handleModalChange(value: boolean) {
    this.isGenerateNationalPPTModuleOpen = value;
    if (GenerateNationalReportComponent) {
      this.onShowGenNationalPPTModal();
    }

    if (this.isGenerateNationalPPTModuleOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }
  // Launch confirmed (or found already launched) by the banner: keep the local state in sync
  onMedicineLaunched(medicineId: number): void {
    if (medicineId === this.medicineId) {
      this.isMedicineLaunched = true;
    }
  }

  // send a singular tooltip info to the card widget depending on which card is redering
  getTooltipById(id: number): TooltipsInterface | undefined {
    return this.tooltipsNationalDashboard.find((t) => t.id === id);
  }
}
